module.exports = __webpack_public_path__ + "static/img/17.3915559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/17.png
// module id = RsVa
// module chunks = 0